import moment from "moment";
import PlanCardField from "./PlanCardField";
import { RootState } from "../../store/root-reducer";
import { connect } from "react-redux";

const DATE_FORMAT = "MMMM Do, YYYY";

function PlanCard({ plan }) {
  return (
    <div className="border-border-gray relative border overflow-hidden cursor-pointer outline-none transition-all w-full select-none rounded-lg mb-4">
      <div className="p-2 gap-1 bg-[#2D6CCA] bg-opacity-10 w-full">
        <h3 className="text-lg font-semibold text-[#2D6CCA]">
          {plan?.programName || plan?.number}
        </h3>
        {plan?.expirationDate && (
          <p className="text-black text-sm font-normal">
            Active until {moment(plan?.expirationDate).format(DATE_FORMAT)}
          </p>
        )}
      </div>
      <div className="bg-white grid gap-1.5 divide-y-[1px] divide-[#F0F0F0] px-2 py-2">
        <PlanCardField
          label={"Purchase Date"}
          value={plan?.purchaseDate}
          date
        />
        <PlanCardField
          label={"Delivery Date"}
          value={plan?.deliveryDate}
          date
        />
        <PlanCardField
          label={"Total Purchase Price"}
          value={plan?.totalPrice}
          price
        />
      </div>
    </div>
  );
}

export default PlanCard;
